<template>
  <v-app id="servicesystem">
    <template v-if="isLoggedIn && (userInfoLoading || preLoadingFinished)">
      <PreLoading />
    </template>

    <template v-else-if="isLoggedIn && $store.state.userInfo">
      <SideNavigationBar />
      <v-main>
        <GeneralHeader />
        <v-container fluid class="pa-0" id="ContentContainer"
          :style="'height:' + computedContentContainerheight + 'px !important;'"
          :class="hasSubmenu ? 'withsubmenu' : ''">
          <NavigationAuthorizer>
            <router-view></router-view>
          </NavigationAuthorizer>
          <ConfirmDialog ref="ConfirmDialog" />
          <MobileRouterButtons />
        </v-container>
      </v-main>
      <AIAssistantButton v-if="$store.state.GlobalSettings.QaiEnabled" />
      <UserChatContainer v-if="$store.state.GlobalSettings.QaiEnabled" />
      <PageFooter />
      <TaskList />
    </template>

    <template v-else>
      <LoginPage />
    </template>

    <GlobalSnackbar :isLoggedIn="isLoggedIn" />
    <ShutdownDialog></ShutdownDialog>
  </v-app>
</template>


<script>
import MobileRouterButtons from "@/components/Buttons/MobileRouterButtons.vue";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog.vue";
import GlobalSnackbar from "@/components/Dialogs/GlobalSnackbar.vue";
import PageFooter from "@/components/Sections/AppSections/PageFooter.vue";
import GeneralHeader from "@/components/Sections/AppSections/PageHeader.vue";
import SideNavigationBar from "@/components/Sections/AppSections/SideNavigationBar.vue";
import NavigationAuthorizer from "@/components/SingleUse/NavigationAuthorizer.vue";
import TaskList from "@/components/Task/TaskList.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import { defaultTheme } from "@/theme/default";
import PreLoading from "@/views/landingpages/PreLoading.vue";
import LoginPage from "@/views/login/LoginWrapperView.vue";
import themes from "devextreme/ui/themes";
import ShutdownDialog from "./ShutdownDialog.vue";
import AIAssistantButton from "./components/AIAssistantButton.vue";
import UserChatContainer from "./components/UserChatContainer.vue";

export default {
  name: "App",
  components: {
    SideNavigationBar,
    LoginPage,
    PreLoading,
    GeneralHeader,
    PageFooter,
    NavigationAuthorizer,
    GlobalSnackbar,
    ConfirmDialog,
    MobileRouterButtons,
    TaskList,
    ShutdownDialog,
    AIAssistantButton,
    UserChatContainer,
  },

  data: () => ({
    themes: defaultTheme(),
    viritualStyleSheet: document.createElement("style"),
  }),

  created() {
    this.$store.dispatch("NotificationStore/connect").then(() => {
      this.$store.dispatch("NotificationStore/route", { Path: this.$route.path, Query: this.$route.query });
    });
    this.setTheme(this.themes[0]);
    if (this.$vuetify.theme.dark) {
      themes.current("generic.dark");
    } else {
      themes.current("generic.light");
    }
  },

  mounted() {
    this.updateUserInfo().then(() => {
      this.$i18n.locale = this.$store.state.userInfo.Uiculture;
      this.$store.dispatch("prefrences/initiatePrefrences");
      if (this.isLoggedIn) {
        this.$store.dispatch("BackgroundUpdater/PreLoading");
      }
    }, error => {
      console.log(`Code 0x1 (Userinfo): ${error}`);
    });
    this.$store.state.clientheight = window.innerHeight;
    window.addEventListener("resize", () => {
      this.$store.state.clientheight = window.innerHeight;
    });

    this.subscribe();
  },

  beforeDestroy() {
    this.unSubscribe();
  },

  methods: {
    events() {
      var clientRefreshEvent = [SRConst.EventKeys.RefreshClientsEvent, this.clientRefresh];
      var userInfoRefreshEvent = [SRConst.EventKeys.RefreshUserInfoEvent, this.refreshUserInfo];
      return [clientRefreshEvent, userInfoRefreshEvent]
    },
    subscribe() {
      this.events().forEach(e => {
        this.$store.dispatch("NotificationStore/subscribe", e);
      });
    },
    unSubscribe() {
      this.events().forEach(e => {
        this.$store.dispatch("NotificationStore/unsubscribe", e);
      });
    },

    clientRefresh(data) {
      var myid = this.userInfo.Id;
      console.log("Client refresh", myid, data.userIdList);
      var targetedUsers = data.userIdList;
      if (!targetedUsers ||
        !targetedUsers.length ||
        targetedUsers.includes(myid)
      ) {
        location.reload(true);
      }
    },

    refreshUserInfo(data) {
      var myid = this.userInfo.Id;
      console.log("Forced UserInfo refresh", myid, data.userIdList);
      var targetedUsers = data.userIdList;
      if (!targetedUsers ||
        !targetedUsers.length ||
        targetedUsers.includes(myid)
      ) {
        this.$store.dispatch("getUserInfo", true);
      }
    },

    setTheme(theme) {
      // close menu
      //this.menu = false;
      const name = theme.name;
      const dark = theme.dark;
      const light = theme.light;
      if (this.$vuetify.theme.dark) {
        this.dynamicGradient = theme.darkGradient;
      } else {
        this.dynamicGradient = theme.lightGradient;
      }
      // set themes
      Object.keys(dark).forEach((i) => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach((i) => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name;
    },

    updateUserInfo() {
      if (this.$store.state.token && !this.userInfo) {
        return this.$store.dispatch("getUserInfo").finally(() => {
          this.hideSplash();
        });
      } else {
        this.hideSplash();
        return Promise.reject();
      }
    },

    hideSplash() {
      document.head.appendChild(this.viritualStyleSheet);
      this.viritualStyleSheet.disabled = false;
      setTimeout(() => this.viritualStyleSheet.sheet.insertRule("#splash {opacity: 0;}", 0), 500);
      setTimeout(() => this.viritualStyleSheet.sheet.insertRule("#splash {display: none;}", 0), 800);
    },

    setContentContainerheight() {
      var headerheight = this.isPadBool ? 56 : 64;
      var submenuheight = this.hasSubmenu ? 48 : 0;
      var footerheight = 30;
      var subtractamout = headerheight + submenuheight + footerheight;
      var result = this.ClientHeight - subtractamout;
      this.$store.dispatch('navstore/setContentContainerHeight', result);
      return result;
    }
  },

  computed: {
    isValidating() {
      if (this.$store.state.token && this.userInfo) {
        return false;
      } else if (!this.$store.state.token && !this.userInfo) {
        return false;
      }
      return true;
    },

    isLoggedIn() {
      return this.$store.state.token != null;
    },

    userInfo() {
      return this.$store.getters["userInfo"];
    },
    userInfoLoading() {
      return this.$store.getters["userInfoLoading"];
    },

    hasSubmenu() {
      return this.$store.getters['navstore/HeaderHasSubmenu'];
    },

    preLoadingFinished() {
      return Object.keys(this.$store.state.BackgroundUpdater).filter(
        (x) => this.$store.state.BackgroundUpdater[x].Value === null
      ).length;
    },

    computedContentContainerheight() {
      return this.setContentContainerheight();
    },
  },

  watch: {
    $route(val) {
      this.$store.dispatch("NotificationStore/route", { Path: val.path, Query: val.query });
    },

    isLoggedIn: function (val) {
      if (val) {
        this.$store.dispatch("BackgroundUpdater/PreLoading");
      }
    },
  },
};
</script>


<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Darker+Grotesque:wght@500&family=Source+Code+Pro&display=swap");
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');
/*$font-family: "Roboto", serif;*/
$font-family: "Nunito Sans";

body {
  font-family: $font-family;
}

.dx-datagrid {
  font-family: $font-family;
  font-size: 12px;
}

#servicesystem {
  font-family: $font-family;
}

h1 {
  font-size: 1.5em;
}

h2 {
  font-size: 1.35em;
}

h3 {
  font-size: 1.2em;
}

h4 {
  font-size: 1.1em;
}

h5 {
  font-size: 1em;
}

h6 {
  font-size: 0.95em;
}

$body-font-size: 12.5px;

body {
  font-size: $body-font-size;
}

p {
  font-size: $body-font-size !important;
}

.v-list-item__title {
  font-size: 13px;
}

.v-list-item__subtitle {
  font-size: 13px;
}

.v-btn.v-size--default {
  font-size: 12px;
}

.v-btn.v-size--small {
  font-size: 10px;
}

.v-input {
  font-size: unset;
}

.v-expansion-panel-header {
  font-size: unset;
}

td {
  font-size: unset !important;
}

/*Fix to prevent headers from word wrapping and adding a "..." ending when they overflow */
.nowrapheader {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* default styling for splitpanes */
.listpane {
  border-right: 1px solid rgb(245, 245, 245);
}

/* Fix for text that does not conform to default text color */
.useThemeTextColor {
  /* //TODO: make this global and make it use vuetify text color*/
  color: var(--v-dark-text-base) !important;
}

/* higlighting for selected and deselected list elements */
.ListItemSelected {
  border: 1px solid var(--v-primary-base) !important;
  border-right: none !important;
  /*background-color: rgb(226, 231, 255) !important;*/
}

.ListItemDeselected {
  border: 1px dotted var(--v-primary-lighten2) !important;
  border-right: none !important;
  /*background-color: rgb(240, 240, 240) !important;*/
}

/* BUG FIX - Tab menu doesnt hide the left icon size */
.v-slide-group__prev {
  display: none !important;
}

/* BUG FIX - Cursor*/
.v-navigation-drawer__content {
  cursor: default !important;
}

/* BUG FIX - Expancion panels have way too much padding by default */
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-application {
  // This is where we'll add all the md-typography classes
}

/* element markup to use most readable text theme compliant */
[font-weight-black] {
  color: var(--v-text-base) !important;
  font-weight: 900;
}

.v-chip.v-size--small {
  font-size: 11px;
}

.linkStyleButton {
  color: var(--v-primary-base) !important;
  background-color: white !important;
  width: 100%;
  height: 52px !important;
  border: none;
  border-radius: 0;
  box-shadow: none !important;
  text-transform: none !important;
  font-family: inherit !important;
}

.linkStyleButton:hover {
  text-decoration: underline;
}

.linkStyleButton:hover:before,
.linkStyleButton:focus:before,
.linkStyleButton:hover:after,
.linkStyleButton:focus:after {
  background-color: #ccc;
}

.square-button {
  height: 25px !important;
  min-width: 25px !important;
  padding: 0px !important;
  margin: 0px !important;
}

.v-app-bar__nav-icon {
  height: 35px !important;
  width: 35px !important;
  min-width: 25px !important;
  padding: 0px !important;
  margin: 0px !important;
  border-radius: 5px !important;
}

.invoice-comment {
  font-style: italic !important;
}

.v-btn--is-elevated {
  box-shadow: none !important;
}

/* BUG FIX - Higher footer elevation*/
.v-footer--absolute,
.v-footer--fixed {
  z-index: 100 !important;
}

/*Text blur*/
.blurred {
  color: transparent !important;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5) !important;
}

/* Content height classes */
#ContentContainer {
  background-color: var(--v-contentboxBackground-base) !important;
}

.pane {
  background-color: var(--v-background-base) !important;
}

.pane.inset {
  -moz-box-shadow: inset 0 0 5px var(--v-header-darken2) !important;
  -webkit-box-shadow: inset 0 0 5px var(--v-header-darken2) !important;
  box-shadow: inset 0 0 5px var(--v-header-darken2) !important;
}

.previewpane {
  background-color: var(--v-previewcolor-base) !important;
}

#ContentContainer,
#ContentContainer .pane {
  // vertical scrolling for content that exceeds screen height
  overflow-y: overlay !important;
  height: calc(100vh - 94.5px) !important;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  #ContentContainer,
  #ContentContainer .pane {
    overflow-y: auto !important;
  }
}

#ContentContainer.withsubmenu,
#ContentContainer.withsubmenu .pane {
  /*background-color: red;*/
  height: calc(100vh - 142px) !important;
}

@media only screen and (max-width: 1024px) {

  #ContentContainer,
  #ContentContainer .pane {
    height: calc(100vh - 86px) !important;
  }

  #ContentContainer.withsubmenu,
  #ContentContainer.withsubmenu .pane {
    /*background-color: red;*/
    height: calc(100vh - 134px) !important;
  }
}

.v-application--wrap {
  min-height: unset !important;
}

.Deleted {
  /*text-decoration: line-through !important;*/
}

.Deleted::before {
  content: "";
  background-color: red;
  max-height: 4px !important;
  min-height: 4px !important;
  width: calc(100% - 40px);
  top: 25px;
  left: 20px;
  right: 20px;
  position: absolute;
  z-index: 2;
  opacity: 0.3 !important;
}

/*
.Deleted::before,
.Deleted::after {
  content: "";
  background-color: red;
  max-height: 2px !important;
  min-height: 2px !important;
  width: 100%;
  top: 50% !important;
  left: 0;
  transform: rotate(3deg);
  position: absolute;
  z-index: 2;
  opacity: 0.5 !important;
}
.Deleted::after {
  transform: rotate(-3deg);
}
*/

.dx-widget {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.99em !important;
}

.dx-overlay-wrapper {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.99em !important;
}

.dx-draggable-clone {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.85em !important;
  opacity: 0.5;
}

.OddMarkedList>div:not(.li-header):not(.ignoreodd) {
  border-top: 1px solid #00000012;
}

.OddMarkedList>div:nth-child(odd):not(.li-header):not(.ignoreodd) {
  background-color: var(--v-list-odd-marked-base);
}

.v-list-item.newcolor {
  background-color: var(--v-list-new-base) !important;
}

.v-list-item.changecolor {
  background-color: var(--v-list-change-base) !important;
}

.v-list-item.errorcolor {
  background-color: var(--v-list-error-base) !important;
}

.v-list-item.deletedcolor {
  background-color: var(--v-list-deleted-base) !important;
}

/* Padlock icon on disbled switches to make it clear that they are locked */
.v-input--switch.v-input--is-disabled .v-input--switch__thumb {
  background-image: url("../public/padlock.png");
  background-position: center;
  background-size: cover;
}

.halficon {
  width: 12.5px !important;
  overflow: hidden;
  margin-right: 3px;
}

.halficon.left {
  justify-content: start !important;
}

.halficon.right {
  justify-content: end !important;
}

.v-menu__content {
  overflow: overlay !important;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .v-menu__content {
    overflow: auto !important;
  }
}

.v-select-list {
  padding-top: 0;
  padding-bottom: 0;
}

.neg-mt-1 {
  margin-top: -4px !important;
}

.neg-mt-2 {
  margin-top: -8px !important;
}

.neg-mt-3 {
  margin-top: -12px !important;
}

.neg-mt-4 {
  margin-top: -16px !important;
}

.neg-mt-5 {
  margin-top: -20px !important;
}

.neg-mt-6 {
  margin-top: -24px !important;
}

.neg-mt-7 {
  margin-top: -28px !important;
}

.neg-mt-8 {
  margin-top: -32px !important;
}

.overflow-overlay {
  overflow: overlay !important;
}

.overflow-x-overlay {
  overflow-x: overlay !important;
}

.overflow-y-overlay {
  overflow-x: overlay !important;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .overflow-overlay {
    overflow: auto !important;
  }

  .overflow-x-overlay {
    overflow-x: auto !important;
  }

  .overflow-y-overlay {
    overflow-x: auto !important;
  }
}

.v--dark-text {
  color: var(--v-dark-text-base) !important;
}


.hovercol {
  background-color: #00000005;
  cursor: pointer;
}

.hovercol:hover {
  background-color: #0000000f;
}

.hovercol2 {
  background-color: #0000000d;
  cursor: pointer;
}

.hovercol2:hover {
  background-color: #00000020;
}


.rounded-tab {
  //margin-top: 8px;
  border: 1px solid rgb(217, 217, 217);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-transform: none;
}

.v-tabs:not(.mandatory) .rounded-tab:not(.flowout) {
  border: none;
}

.rounded-tab.flowout {
  background-color: rgb(253, 253, 253) !important;
  z-index: 10;
}

.rounded-tab.flowout::after {
  content: "";
  background-color: rgb(253, 253, 253) !important;
  width: 100%;
  height: 3px;
  right: 0;
  bottom: -2px;
  z-index: 11;
  opacity: 1 !important;
  border-radius: 0px;
  position: absolute;
}

.v-tabs.mandatory .rounded-tab:not(.flowout) {
  background-color: rgb(246, 246, 246) !important;
}

.v-tabs.mandatory .rounded-tab:not(:first-child):not(.flowout) {
  border-top-left-radius: 0px;
  margin-left: -4px;
  border-left: none;
  padding-left: 16px !important;
}

.v-tabs.mandatory .rounded-tab:not(:last-child):not(.flowout) {
  border-top-right-radius: 0px;
  margin-right: -4px;
  border-right: none;
  padding-right: 16px !important;
}
</style>